import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/organisms/Table';
import { murmurhash } from '../../../lib/js/hash';
import { SearchResultTeaser } from '../../../components/molecules/SearchResultTeaser/SearchResultTeaser';
import { DateFormat } from '../../../_lib/components/DateFormat';
import { StateIndicator } from '../../../_lib/components/StateIndicator';
import { PagePackState, PagePackStates } from '../../../types/api/PagePackState';

type item = {
  pageLink: any;
  breadcrumb: any[];
  validUntil: string;
  attachments: any[];
  elevated: boolean;
  hasReadRestrictions: boolean;
  confidentialLevel: string;
  searchListTemplate: string;
  packState: PagePackStates;
  lastEditorialActivityType: 'publish' | 'edit' | 'create';
  lastEditorialActivityDate: string;
};

type EditorialDashboardResultTableProps = {
  items: item[];
};

export function EditorialDashboardResultTable({ items }: EditorialDashboardResultTableProps) {
  const { t } = useSonTranslation('EditorialDashBoard');

  function getEditorialDate(item: item) {
    return (
      <>
        <p>{t(`lastEditorialActivityType.${item.lastEditorialActivityType}`)}</p>
        <DateFormat date={item.lastEditorialActivityDate} />
      </>
    );
  }

  const getStatusIndicatorState = (packState: PagePackStates) => {
    switch (packState) {
      case PagePackState.ONLY_PUBLISHED_VERSION:
        return 'green';
      case PagePackState.ONLY_DRAFT_VERSION:
        return 'red';
      case PagePackState.PUBLISHED_WITH_DRAFT_VERSION:
        return 'yellow';
      default:
        return 'red';
    }
  };

  return (
    <Table caption={t('caption')} removeOnPaste>
      <TableHead>
        <TableRow>
          <TableCell>{t('label.content')}</TableCell>
          <TableCell>{t('label.editorialDate')}</TableCell>
          <TableCell>{t('label.validUntil')}</TableCell>
          <TableCell>{t('label.packState')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map(item => (
          <TableRow key={`result-item-${murmurhash(item)}`}>
            <TableCell dataHead={t('label.content')}>
              <SearchResultTeaser {...item} />
            </TableCell>
            <TableCell dataHead={t('label.editorialDate')}>{getEditorialDate(item)}</TableCell>
            <TableCell dataHead={t('label.validUntil')}>
              <DateFormat date={item.validUntil} />
            </TableCell>
            <TableCell dataHead={t('label.packState')}>
              <StateIndicator status={getStatusIndicatorState(item.packState)} modifier={['inline-block', 'border']} />
              {t(`packState.${item.packState}`)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
